const getSelectedFormInputs = () => {
  let filterTypes = document.querySelectorAll(
    "input[name='filter-types[]']:checked"
  )
  let categoryInput = document.getElementById('filter-category')
  let combinedCategories = ''
  let combinedTopics = ''
  if (filterTypes.length > 0) {
    for (let i = 0; i < filterTypes.length; i++) {
      if (i > 0) {
        combinedCategories += ','
        combinedTopics += ', '
      }
      combinedCategories += filterTypes[i].value
      combinedTopics += filterTypes[i].parentElement.innerText.replace(
        / /gi,
        ''
      )
    }
  } else {
    sessionStorage.removeItem('resourceCenterFilters')
    sessionStorage.removeItem('resourceCenterSubFilters')
  }

  if (window._satellite && window._satellite.track) {
    window._satellite.track('getSelectedResources', combinedTopics)
  }

  categoryInput.value = combinedCategories
  document.getElementById('question-form').submit()
}

document.addEventListener('DOMContentLoaded', function (event) {
  // Your code to run since DOM is loaded and ready
  let btnSubmit = document.getElementById('btnResourceLanding')
  btnSubmit.addEventListener('click', e => {
    e.preventDefault()
    getSelectedFormInputs()
  })

  let topics = document.querySelectorAll("input[name='filter-types[]']")
  topics.forEach(chkbox => {
    // this code is because firefox does not support :has. It can be removed later once support is added.
    chkbox.addEventListener('change', e => {
      if (e.target.checked) {
        e.target.parentElement.classList.add('checked')
      } else {
        e.target.parentElement.classList.remove('checked')
      }
    })
    chkbox.addEventListener('focus', e => {
      e.target.parentElement.classList.add('focused')
    })
    chkbox.addEventListener('focusout', e => {
      e.target.parentElement.classList.remove('focused')
    })

    if (chkbox.checked) {
      chkbox.parentElement.classList.add('checked')
    } else {
      chkbox.parentElement.classList.remove('checked')
    }
  })
})
